import { useCreateManualFormModal } from '~/components/Modals/ManualFormModal';
import { useAppNavigation } from '~/hooks/nav.hook';
import { translate } from '~/utils/translation.utils';

export const useSupportRequestByIdInputModal = () => {
  const navigation = useAppNavigation();

  return useCreateManualFormModal({
    title: translate('supportRequests.supportRef'),
    subtitle: translate('supportRequests.enterRef'),
    formData: [
      {
        items: [
          {
            type: 'text',
            label: translate('supportRequests.supportRef'),
            id: 'supportId',
          },
        ],
      },
    ],
    onConfirm: (value) => {
      navigation.navigate('SupportRequestById', { ref: value.supportId });
    },
  });
};
